import { FunctionComponent, PropsWithChildren, ReactElement } from 'react';

import TextField, { TextFieldProps } from '@mui/material/TextField';

const BaseFormInputField: FunctionComponent<TextFieldProps> = (
  props: PropsWithChildren<TextFieldProps>
): ReactElement => {
  const { children, ...textFieldProps } = props;

  const baseInputFieldProps = {
    fullWidth: true,
    type: 'text',
    autoComplete: 'off',
    ...textFieldProps,
    InputProps: {
      disableUnderline: true,
      classes: {
        focused: 'input-focused',
      },
      ...textFieldProps.InputProps,
      'data-testid': 'base-input-wrapper',
    },
    InputLabelProps: {
      classes: {
        filled: 'input-label-filled',
        error: 'input-label-error',
        focused: 'input-label-focused',
      },
      ...textFieldProps.InputLabelProps,
      'data-testid': 'textfield-label',
    },
  };

  return (
    <TextField variant="filled" {...baseInputFieldProps}>
      {children}
    </TextField>
  );
};

export default BaseFormInputField;
